/**
 * Links de boleto dentro do TEXTO da resposta do Vision.
 *
 * O botão "Anexar boleto" nasceu do evento estruturado (`tool_result` com
 * `boleto_url`/`boleto_key`, caminho IXC: key S3 → boleto_redirect). Provedores
 * com cobrança INLINE (SGP: `boleto_url` público em cada linha do listar) não
 * passam por ali — o LLM escolhe o título e escreve o link no markdown, e o
 * atendente ficava sem o anexo. Aqui o link vira botão de forma determinística.
 */

// [texto](url) do markdown + URL solta.
const MD_LINK_RE = /\[([^\]]*)\]\((https?:\/\/[^\s)]+)\)/g;
const BARE_URL_RE = /(?:^|[\s(])(https?:\/\/[^\s)<>]+)/g;

// Só o que tem cara de boleto: nosso redirect, caminho com "boleto", ou PDF.
const BOLETO_URL_RE =
  /vision\/boleto_redirect|\/boleto[s]?\/|boleto[^/]*\.pdf|\.pdf(\?|$)/i;

export const isBoletoUrl = url => BOLETO_URL_RE.test(String(url || ''));

/** [{ url, label }] únicos por URL, na ordem em que aparecem. */
export const extractBoletoLinks = content => {
  const text = String(content || '');
  const seen = new Set();
  const links = [];
  const push = (url, label) => {
    const clean = url.replace(/[.,;:]+$/, '');
    if (!isBoletoUrl(clean) || seen.has(clean)) return;
    seen.add(clean);
    links.push({ url: clean, label: (label || '').trim() });
  };
  [...text.matchAll(MD_LINK_RE)].forEach(match => push(match[2], match[1]));
  [...text.matchAll(BARE_URL_RE)].forEach(match => push(match[1], ''));
  return links;
};

/** Nome do arquivo: último segmento útil da URL, senão boleto.pdf. */
export const boletoFilename = url => {
  try {
    const segment = new URL(url).pathname.split('/').filter(Boolean).pop();
    if (segment && !/boleto_redirect/.test(segment)) {
      return /\.pdf$/i.test(segment) ? segment : `boleto-${segment}.pdf`;
    }
  } catch {
    // URL inválida cai no default
  }
  return 'boleto.pdf';
};
